import React from 'react';
import { Lightbulb } from 'lucide-react';
export const LiuNian: React.FC = () => {
  return <div className="space-y-12" data-id="element-203">
      <div className="text-center mb-10" data-id="element-204">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-205">
          流年分析
        </h1>
        <p className="text-ink-light" data-id="element-206">
          流动的年份，决定你这一年具体会发生什么事。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-207">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-208">
          <Lightbulb size={24} data-id="element-209" />
        </div>
        <div data-id="element-210">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-211">
            小白理解法：年度天气预报
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-212">
            <strong data-id="element-213">流年：</strong>{' '}
            就是当前的年份，比如2024年是甲辰年，2025年是乙巳年。
            <br data-id="element-214" />
            流年就像今年的天气预报。如果流年五行是你八字需要的（用神），今年就晴空万里，做事顺利；
            <br data-id="element-215" />
            如果流年五行是你八字讨厌的（忌神），今年就狂风暴雨，需要谨慎防守。
          </p>
        </div>
      </div>

      <section className="bg-white ink-border p-8 rounded-lg shadow-sm" data-id="element-216">
        <h2 className="text-2xl font-serif text-gold-dark mb-6 border-l-4 border-gold pl-3" data-id="element-217">
          看流年的三大重点
        </h2>
        <div className="space-y-6" data-id="element-218">
          <div className="border-b border-paper-dark pb-4" data-id="element-219">
            <h3 className="font-bold text-ink text-lg mb-2" data-id="element-220">
              1. 流年天干看表象
            </h3>
            <p className="text-ink-light text-sm" data-id="element-221">
              流年天干代表今年发生的事情的表面现象，大家都能看到的事。比如天干透出财星，说明今年跟钱财、投资有关。
            </p>
          </div>
          <div className="border-b border-paper-dark pb-4" data-id="element-222">
            <h3 className="font-bold text-ink text-lg mb-2" data-id="element-223">
              2. 流年地支看实质
            </h3>
            <p className="text-ink-light text-sm" data-id="element-224">
              流年地支代表事情的实质结果，内部的真实情况。地支力量比天干大，决定了这一年最终是吉是凶。
            </p>
          </div>
          <div data-id="element-225">
            <h3 className="font-bold text-ink text-lg mb-2" data-id="element-226">
              3. 流年与八字的互动（刑冲合害）
            </h3>
            <p className="text-ink-light text-sm" data-id="element-227">
              流年地支如果冲了你八字的日支（配偶宫），今年感情可能波动；如果合了财星，今年可能得财。互动越剧烈，发生的事情越明显。
            </p>
          </div>
        </div>
      </section>
    </div>;
};